import { useState, useEffect, useRef } from "react";

/* Exact CSS from original index.html */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;600;700&family=Inter:wght@400;500;600;700&display=swap');

  .kiosk-root * { margin:0; padding:0; box-sizing:border-box; -webkit-tap-highlight-color:transparent; }
  .kiosk-root {
    position:fixed; inset:0;
    background:#0B1220; color:#EDF1F7;
    font-family:"Inter","Segoe UI",system-ui,sans-serif;
    display:flex; flex-direction:column; align-items:center;
    overflow:hidden; user-select:none;
  }
  .kiosk-root .display { font-family:"Space Grotesk","Inter",sans-serif; letter-spacing:-0.02em; }

  .kiosk-header {
    width:100%; padding:28px 40px 0;
    display:flex; justify-content:space-between; align-items:baseline;
  }
  .kiosk-brand { font-size:15px; letter-spacing:.22em; color:#7C8AA3; font-weight:600; }
  .kiosk-brand b { color:#EDF1F7; }
  .kiosk-clock { font-size:22px; font-variant-numeric:tabular-nums; color:#7C8AA3; }
  .kiosk-clock b { color:#EDF1F7; font-weight:600; }

  .kiosk-main {
    flex:1; width:100%; max-width:880px;
    display:flex; flex-direction:column; align-items:center; justify-content:center;
    padding:0 24px;
  }

  .kiosk-screen { display:none; width:100%; flex-direction:column; align-items:center; }
  .kiosk-screen.active { display:flex; }

  /* Screen 1 — select */
  .kiosk-h1 { font-size:clamp(28px,4.5vw,44px); font-weight:600; margin-bottom:6px; text-align:center; }
  .kiosk-sub { color:#7C8AA3; font-size:17px; margin-bottom:48px; text-align:center; }
  .kiosk-actions { display:flex; gap:28px; width:100%; justify-content:center; flex-wrap:wrap; }
  .action-card {
    flex:1 1 280px; max-width:360px; min-height:230px;
    background:#121C30; border:1px solid #1E2A44; border-radius:24px;
    display:flex; flex-direction:column; justify-content:center; align-items:center;
    gap:14px; cursor:pointer; transition:transform .12s ease, border-color .12s ease;
  }
  .action-card:hover { transform:scale(1.02); }
  .action-card:active { transform:scale(.97); }
  .action-card .glyph { font-size:44px; line-height:1; }
  .action-card .label { font-size:26px; font-weight:600; }
  .action-card .hint  { font-size:14px; color:#7C8AA3; }
  #kiosk-card-in  { }
  #kiosk-card-out { }
  #kiosk-card-in:hover  { border-color:#36C2A8; }
  #kiosk-card-out:hover { border-color:#F5A524; }

  /* Screen 2 — capture */
  .kiosk-topline {
    width:100%; display:flex; justify-content:space-between;
    align-items:center; margin-bottom:26px;
  }
  .kiosk-back {
    background:none; border:none; color:#7C8AA3; font-size:17px;
    cursor:pointer; padding:10px 14px;
  }
  .kiosk-chip {
    font-size:14px; letter-spacing:.18em; font-weight:700;
    padding:8px 18px; border-radius:999px; border:1px solid;
  }
  .kiosk-chip.in  { color:#36C2A8; border-color:#36C2A8; }
  .kiosk-chip.out { color:#F5A524; border-color:#F5A524; }

  /* The ring */
  .kiosk-ringwrap {
    position:relative; width:min(56vw,380px);
    aspect-ratio:1; margin-bottom:26px;
  }
  .kiosk-ring {
    position:absolute; inset:0; border-radius:50%;
    padding:7px;
  }
  .kiosk-ring.scanning {
    animation:kiosk-spin 1.1s linear infinite;
  }
  @keyframes kiosk-spin { to { transform:rotate(360deg); } }
  .kiosk-lens {
    position:absolute; inset:7px; border-radius:50%;
    overflow:hidden; background:#000;
    display:flex; align-items:center; justify-content:center;
  }
  .kiosk-lens video {
    width:100%; height:100%; object-fit:cover; transform:scaleX(-1);
  }
  .kiosk-result-glyph {
    position:absolute; font-size:120px; font-weight:700;
  }

  .kiosk-guide { color:#7C8AA3; font-size:16px; margin-bottom:24px; text-align:center; }

  .kiosk-capture-btn {
    border:none; border-radius:999px; padding:20px 54px;
    font-size:21px; font-weight:600; font-family:inherit;
    color:#0B1220; cursor:pointer; transition:transform .1s ease;
  }
  .kiosk-capture-btn:active { transform:scale(.96); }
  .kiosk-capture-btn:disabled { opacity:.45; cursor:not-allowed; }
  .kiosk-capture-btn.btn-in  { background:#36C2A8; }
  .kiosk-capture-btn.btn-out { background:#F5A524; }

  /* Screen 3 — result */
  .kiosk-result-name {
    font-size:clamp(26px,4vw,40px); font-weight:600;
    margin-top:6px; text-align:center;
  }
  .kiosk-result-meta { color:#7C8AA3; font-size:18px; margin-top:8px; text-align:center; }
  .kiosk-result-msg  { font-size:19px; margin-top:18px; text-align:center; }
  .kiosk-ok-text   { color:#3DDC84; }
  .kiosk-fail-text { color:#FF5D5D; }
  .kiosk-result-actions { display:flex; gap:18px; margin-top:34px; }
  .kiosk-ghost-btn {
    background:#121C30; border:1px solid #1E2A44; color:#EDF1F7;
    border-radius:14px; padding:15px 34px; font-size:18px;
    font-family:inherit; cursor:pointer;
  }
  .kiosk-countdown { color:#7C8AA3; font-size:14px; margin-top:22px; }

  .kiosk-footer { padding:0 0 22px; color:#39465F; font-size:12.5px; text-align:center; }
`;

const sleep = ms => new Promise(r => setTimeout(r, ms));

export default function Kiosk({ company: companyCode = null }) {
  const [screen,    setScreen]  = useState("select"); // select | capture | result
  const [action,    setAction]  = useState("checkin");
  const [clock,     setClock]   = useState("");
  const [daypart,   setDaypart] = useState("morning");
  const [guide,     setGuide]   = useState("Align your face inside the circle");
  const [busy,      setBusy]    = useState(false);
  const [result,    setResult]  = useState(null);
  const [countdown, setCountdown] = useState("");

  const videoRef   = useRef(null);
  const streamRef  = useRef(null);
  const timerRef   = useRef(null);
  const canvasRef  = useRef(null);

  /* ── Clock ── */
  useEffect(() => {
    const tick = () => {
      const d = new Date();
      const day = d.toLocaleDateString("en-IN", {weekday:"short",day:"numeric",month:"short"});
      const t   = d.toLocaleTimeString("en-IN", {hour:"2-digit",minute:"2-digit"});
      setClock(`${day} · __TIME__`.replace("__TIME__", t));
      const h = d.getHours();
      setDaypart(h < 12 ? "morning" : h < 17 ? "afternoon" : "evening");
    };
    tick();
    const id = setInterval(tick, 10000);
    return () => clearInterval(id);
  }, []);

  const clockParts = clock.split(" · ");

  const stopCamera = () => {
    streamRef.current?.getTracks().forEach(t => t.stop());
    streamRef.current = null;
  };

  const goHome = () => {
    clearTimeout(timerRef.current);
    stopCamera();
    setBusy(false);
    setResult(null);
    setCountdown("");
    setScreen("select");
    // Optional: exit fullscreen when going home
    // if (document.fullscreenElement) document.exitFullscreen().catch(()=>{});
  };

  const startCapture = async (act) => {
    // Go fullscreen on first interaction (kiosk mode)
    if (!document.fullscreenElement && document.documentElement.requestFullscreen)
      document.documentElement.requestFullscreen().catch(() => {});
    setAction(act);
    setBusy(false);
    setGuide("Align your face inside the circle");
    setScreen("capture");
    try {
      if (!streamRef.current) {
        streamRef.current = await navigator.mediaDevices.getUserMedia({
          video: { facingMode:"user", width:{ideal:1280}, height:{ideal:720} }, audio:false
        });
      }
      if (videoRef.current) videoRef.current.srcObject = streamRef.current;
    } catch {
      setGuide("Camera unavailable — check permissions / HTTPS.");
    }
  };

  const grabFrame = () => {
    const video = videoRef.current;
    if (!video?.videoWidth) return null;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth; canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    return canvas.toDataURL("image/jpeg", 0.85);
  };

  const doCapture = async () => {
    const video = videoRef.current;
    if (!video?.videoWidth) return;
    setBusy(true);
    setGuide("Hold still…");
    const images_b64 = [];
    for (let i = 0; i < 4; i++) {
      const f = grabFrame();
      if (f) images_b64.push(f);
      if (i < 3) await sleep(280);
    }
    let data;
    try {
      const r = await fetch("/api/recognize", {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({ images_b64, action, kiosk_id:"kiosk-1", company_code: companyCode?.toUpperCase() || null }),
      });
      data = await r.json();
      if (!r.ok) data = { matched:false, message: data.detail || "Server error. Try again." };
    } catch {
      data = { matched:false, message:"Cannot reach server. Tell IT." };
    }
    stopCamera();
    setResult(data);
    setScreen("result");
    setBusy(false);

    // countdown
    let secs = data.matched ? 5 : 12;
    const step = () => {
      setCountdown(`Returning home in ${secs}s`);
      if (secs-- <= 0) { goHome(); return; }
      timerRef.current = setTimeout(step, 1000);
    };
    clearTimeout(timerRef.current);
    step();
  };

  const isIn  = action === "checkin";
  const accent = isIn ? "#36C2A8" : "#F5A524";
  const ok = result?.matched;

  const ringBg = (scanning) => scanning
    ? `conic-gradient(from 0deg, ${accent} 0 18%, #1E2A44 18% 100%)`
    : `conic-gradient(${ok == null ? accent : ok ? "#3DDC84" : "#FF5D5D"} 0 100%)`;

  return (
    <>
      <style>{CSS}</style>
      <canvas ref={canvasRef} style={{display:"none"}}/>

      <div className="kiosk-root">
        {/* Header */}
        <header className="kiosk-header">
          <div className="kiosk-brand display"><b>INVINCIBLE</b> · {companyCode ? companyCode.toUpperCase() : "ATTENDANCE"}</div>
          <div className="kiosk-clock">
            {clockParts[0]} · <b>{clockParts[1]}</b>
          </div>
        </header>

        {/* Main */}
        <main className="kiosk-main">

          {/* Screen 1 — Select action */}
          <section className={`kiosk-screen ${screen==="select"?"active":""}`}>
            <h1 className="kiosk-h1 display">Good {daypart}</h1>
            <p className="kiosk-sub">Choose an action, then look at the camera.</p>
            <div className="kiosk-actions">
              <div className="action-card" id="kiosk-card-in"
                onClick={() => startCapture("checkin")}>
                <div className="glyph" style={{color:"#36C2A8"}}>→]</div>
                <div className="label display">Check In</div>
                <div className="hint">Starting your day</div>
              </div>
              <div className="action-card" id="kiosk-card-out"
                onClick={() => startCapture("checkout")}>
                <div className="glyph" style={{color:"#F5A524"}}>[→</div>
                <div className="label display">Check Out</div>
                <div className="hint">Wrapping up</div>
              </div>
            </div>
          </section>

          {/* Screen 2 — Capture */}
          <section className={`kiosk-screen ${screen==="capture"?"active":""}`}>
            <div className="kiosk-topline">
              <button className="kiosk-back" onClick={goHome}>← Back</button>
              <span className={`kiosk-chip display ${isIn?"in":"out"}`}>
                {isIn?"CHECK-IN":"CHECK-OUT"}
              </span>
              <span style={{width:74}}/>
            </div>

            <div className="kiosk-ringwrap">
              <div className="kiosk-ring" style={{
                background: ringBg(busy),
                animation: busy ? "kiosk-spin 1.1s linear infinite" : "none",
              }}>
                <div className="kiosk-lens">
                  <video ref={videoRef} autoPlay playsInline muted/>
                </div>
              </div>
            </div>

            <p className="kiosk-guide">{guide}</p>

            <button
              className={`kiosk-capture-btn ${isIn?"btn-in":"btn-out"}`}
              disabled={busy}
              onClick={doCapture}>
              {busy ? "Identifying…" : "◉\u00A0 Capture Photo"}
            </button>
          </section>

          {/* Screen 3 — Result */}
          <section className={`kiosk-screen ${screen==="result"?"active":""}`}>
            <div className="kiosk-ringwrap">
              <div className="kiosk-ring" style={{
                background:`conic-gradient(${ok?"#3DDC84":"#FF5D5D"} 0 100%)`,
              }}>
                <div className="kiosk-lens" style={{background:"#0B1220"}}>
                  <div className="kiosk-result-glyph"
                    style={{color: ok?"#3DDC84":"#FF5D5D"}}>
                    {ok ? "✓" : "✕"}
                  </div>
                </div>
              </div>
            </div>

            <div className="kiosk-result-name display">
              {ok ? result?.employee?.name : "Employee not recognized"}
            </div>
            {ok && (
              <div className="kiosk-result-meta">
                {result?.employee?.employee_id}
                {result?.employee?.department ? ` · ${result.employee.department}` : ""}
                {result?.confidence ? ` · ${result.confidence}% match` : ""}
              </div>
            )}
            <div className={`kiosk-result-msg ${ok?"kiosk-ok-text":"kiosk-fail-text"}`}>
              {result?.message}
            </div>
            <div className="kiosk-result-actions">
              <button className="kiosk-ghost-btn" onClick={() => startCapture(action)}>Retry</button>
              <button className="kiosk-ghost-btn" onClick={goHome}>Home</button>
            </div>
            <div className="kiosk-countdown">{countdown}</div>
          </section>

        </main>

        <footer className="kiosk-footer">
          Photos are used only for identification · Invincible Web Solutions LLP
        </footer>
      </div>
    </>
  );
}
